import { HttpClient } from '@opallabs/api'

export const createStory = ({ story }) => {
  const storyBody = {
    data: {
      type: 'story',
      attributes: {
        name: story.name,
        description: story.description,
        duplicated_from_story_id: story.duplicatedFromStoryId,
        duplicate_to_brand_id: story.duplicateToBrandId,
        duplication_mode: story.duplicationOption,
        prompt: story.prompt,
        prompt_type: story.promptType,
        scheduled_start_at: story.scheduledStartAt,
        scheduled_end_at: story.scheduledEndAt,
      },
      relationships: {
        brand: {
          data: {
            id: story.brandId,
            type: 'brand',
          },
        },
      },
    },
  }

  return HttpClient()
    .post(`/stories/v2`, storyBody)
    .catch((err) => {
      console.error(err)
      throw err
    })
}
